import { DatadogEventProcessor } from ".";

export const REDACTED_PARAM = "REDACTED";

/** Redacts search params from a URL
 * A query string is a place we can leak sensitive info. Some examples are:
 * One time use tokens (password reset, 2FA setup links, etc)
 * Filter/search parameters (email activity advanced search)
 */
const redactSearchParams = (url: string) => {
  try {
    const outputUrl = new URL(url);
    outputUrl.searchParams.forEach((_, key) => {
      outputUrl.searchParams.set(key, REDACTED_PARAM);
    });
    return outputUrl.toString();
  } catch {
    return "";
  }
};

/** Redacts search param values from all editable URLs of a RUM event.
 * https://docs.datadoghq.com/real_user_monitoring/browser/modifying_data_and_context/?tab=npm#modify-the-content-of-a-rum-event
 */
export const redactUrlSearchParams: DatadogEventProcessor = (event) => {
  event.view.url = redactSearchParams(event.view.url);

  if (event.view.referrer) {
    event.view.referrer = redactSearchParams(event.view.referrer);
  }

  if (event.type === "resource") {
    event.resource.url = redactSearchParams(event.resource.url);
  }

  if (event.type === "error" && event.error.resource?.url) {
    event.error.resource.url = redactSearchParams(event.error.resource.url);
  }
};
